import { createSlice } from "@reduxjs/toolkit";
import {
  bankInfo,
  fetchTerritoryInfo,
  getBankList,
  getCountriesCode,
  fetchRegionInfoByTerritoryName,
  getAddressList,
  fetchDistrictInfo,
  fetchSubRegisterOfficeInfo,
} from "api/formDisplay";
import { getAllOptionList } from "api/formDisplay";

const initialState = {
  countryData: [],
  bankList: [],
  CompanyList:[],
  TerritoryList: [],
  RegionList: [],
  UnitList: [],
  bankInfo: {},
  status: false,
  addressList:[],
  districtList: [], 
  subregisterofficeList : [],
  allOptionList:[]
};

export const staticData = createSlice({
  name: "staticData",
  initialState,
  reducers: {
    setLoadingState: (state, action) => {
      state.status = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCountriesCode.pending, (state, action) => {
        state.status = true;
      })
      .addCase(getCountriesCode.fulfilled, (state, action) => {
        state.countryData = action.payload;
        state.status = false;
      })
      .addCase(getCountriesCode.rejected, (state, action) => {
        state.status = true;
      });
    builder
      .addCase(getBankList.pending, (state, action) => {
        state.bankList = [];
      })
      .addCase(getBankList.fulfilled, (state, action) => {
        state.bankList = action.payload?.BankList;
      })
      .addCase(getBankList.rejected, (state, action) => {
        state.bankList = [];
      });
    builder
      .addCase(bankInfo.pending, (state, action) => {
        state.bankInfo = {};
      })
      .addCase(bankInfo.fulfilled, (state, action) => {
        state.bankInfo = action.payload;
      })
      .addCase(bankInfo.rejected, (state, action) => {
        state.bankInfo = {};
      });
    builder
      .addCase(fetchTerritoryInfo.pending, (state, action) => {
        state.TerritoryList = {};
        state.RegionList = {};
        state.UnitList = {};
        state.CompanyList={};
      })
      .addCase(fetchTerritoryInfo.fulfilled, (state, action) => {
        state.TerritoryList = action.payload?.Territory;
        state.CompanyList=action.payload?.Company;
        if(state.TerritoryList?.length === 1){
          state.RegionList = action.payload?.Region;
          state.UnitList = action.payload?.Unit;
        }
       
      })

      .addCase(fetchTerritoryInfo.rejected, (state, action) => {
        state.TerritoryList = {};
        state.RegionList = {};
        state.UnitList = {};
      });
    builder
      .addCase(fetchRegionInfoByTerritoryName.pending, (state, action) => {
        state.RegionList = {};
        state.UnitList = {};
      })
      .addCase(fetchRegionInfoByTerritoryName.fulfilled, (state, action) => {
        state.RegionList = action.payload?.Region;
        state.UnitList = action.payload?.Unit;
        state.TerritoryList = action.payload?.Territory;
        state.CompanyList=action.payload?.Company;
        
      })

      .addCase(fetchRegionInfoByTerritoryName.rejected, (state, action) => {
        state.RegionList = {};
        state.UnitList = {};
      });

      builder
      .addCase(getAddressList.pending, (state, action) => {
        state.status = true;
      })
      .addCase(getAddressList.fulfilled, (state, action) => {
        state.addressList = action.payload;
        state.status = false;
      })
      .addCase(getAddressList.rejected, (state, action) => {
        state.status = true;
      })
      .addCase(getAllOptionList.pending, (state, action) => {
        state.status = true;
      })
      .addCase(getAllOptionList.fulfilled, (state, action) => {
        state.allOptionList = action.payload;
        state.status = false;
      })
      .addCase(getAllOptionList.rejected, (state, action) => {
        state.status = true;
      });
      builder
      .addCase(fetchDistrictInfo.pending, (state, action) => {
        state.status = true;
      })
      .addCase(fetchDistrictInfo.fulfilled, (state, action) => {
        state.districtList = action.payload;
        state.status = false;
      })
      .addCase(fetchDistrictInfo.rejected, (state, action) => {
        state.status = true;
      });
      builder
      .addCase(fetchSubRegisterOfficeInfo.pending, (state, action) => {
        state.status = true;
      })
      .addCase(fetchSubRegisterOfficeInfo.fulfilled, (state, action) => {
        state.subregisterofficeList = action.payload;
        state.status = false;
      })
      .addCase(fetchSubRegisterOfficeInfo.rejected, (state, action) => {
        state.status = true;
      });
  },
});

export const { setLoadingState } = staticData.actions;
export default staticData.reducer;
